import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileUpload as Icon } from '@fortawesome/free-solid-svg-icons';

export default () => <FontAwesomeIcon icon={Icon} />;
